import { Controller } from '@hotwired/stimulus';

// A collapsible panel initialises itself rather than waiting to be collected
// on page load, so markup that arrives later -- from a Turbo stream replacing
// the opening hours, say -- behaves like markup the server rendered.
export default class extends Controller {
  connect() {
    import(
      /* webpackChunkName: "vanilla-collapsible-content" */ '@morsedigital/vanilla-collapsible-content'
    ).then(({ default: CollapsibleContent }) => {
      if (!this.element.isConnected) return;

      new CollapsibleContent({
        element: this.element,
        bodyContainerClass: 'collapsible-content-body',
        itemContainerClass: 'collapsible-content-item',
        toggleContainerClass: 'collapsible-content-toggle',
      });
    });
  }
}
